<template>
  <a-spin :spinning="isOrderProcessing" tip="Order is being processed...">
    <div class="spin-content">
      <div :class="['carousel orderCard', isAnimate ? 'activeAnimate' : '', isSeeAll ? 'activeSeeAll' : '']">
        <div class="mainCarousel">
          <swiper ref="swiper" class="swiper" :options="swiperOption" @click="detroySeeAll">
            <swiper-slide v-show="!isSeeAll">
              <div class="item-0">
                <Step0 />
                <div class="nav-control">
                  <button class="nav-next" @click="doNextToMain">Next <i>→</i></button>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide v-for="n in stepsByRole.length" :key="n" v-show="!isSeeAll || n !== 4" :class="[isErrorAnimated && getCurrentStep(currStep) === getCurrentStep(errorStep) && 'animated']">
              <div class="item">
                <span class="number">{{ getCurrentStep(n) }}</span>
                <component
                  :is="`Step${steps.findIndex(s => s === stepsByRole[n - 1]) + 1}`"
                  :source="dataSources"
                  v-model="dataInput"
                  :ref="`Step${n}`"
                  :step="n"
                  @onInvalid="handleError"
                  @onAnimated="handleError"
                  @onNextPage="e => onChangeSlide('next', e)"
                  @onNextTextChanged="nextText = $event"
                  @onSelectCard="doSelectCard"
                />
                <div class="nav-control">
                  <button class="nav-prev" @click="onChangeSlide()" v-if="n > 1"><i>←</i> Prev</button>
                  <button class="nav-next" :class="[n === 1 && 'no-back']" @click="onChangeSlide('next')" v-html="getNextText"></button>
                  <p v-if="isError && getCurrentStep(currStep) === getCurrentStep(errorStep)" :class="['error', `step${errorStep}`]">{{ errorText }}</p>
                </div>
              </div>
              <p class="error-other" v-if="isError && getCurrentStep(currStep) === getCurrentStep(errorStep + 1)">There are errors on the form. Please fix them before continuing.</p>
            </swiper-slide>
            <swiper-slide v-show="!isSeeAll">
              <div class="item-0">
                <Step16 ref="Step16" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <template v-if="currStep > 0 && currStep < stepsByRole.length + 1">
          <div class="pagingControl" v-if="isDesktop">
            <template v-for="n in stepsByRole.length">
              <button
                v-if="stepsByRole[n - 1]"
                :class="[getCurrentStep(currStep) === getCurrentStep(n) && 'active', n === 1 && 'done', getCurrentStep(n) === getCurrentStep(errorStep) && 'error']"
                :key="n"
                @click="onClickPagination(n)"
              >
                <span class="tooltip">{{ getCurrentStep(n) }}. {{ stepsByRole[n - 1] }} </span>
                <i class="dot"></i>
              </button>
            </template>
          </div>
          <div class="see-all">
            <div class="text">{{ getCurrentStep(currStep) }} of {{ stepsByRole.length - 1 }}</div>
            <button @click="seeAll">See All</button>
          </div>
        </template>

        <a-modal :title="'Make The Payment'" :visible="showBillingModal" :width="isDesktop ? 800 : 520" centered :footer="null" :closable="false">
          <a-row>
            <a-col :md="{ span: 22, offset: 1 }">
              <p style="font-size: 20px">{{ chargableMessage }}</p>
              <div class="mb-4">
                <h6 class="mb-4">Select the payment method</h6>
                <a-radio-group v-model="paymentMethod">
                  <a-radio :value="'current'" v-if="billingInfo"> Use the card on file </a-radio>
                  <a-radio :value="'new'"> Use a new card </a-radio>
                </a-radio-group>
                <div class="form-group-coupon-code mt-3">
                  <label>Coupon codes:</label>
                  <input v-model="coupon_codes" name="coupon_codes" class="ant-input" style="width: 200px; margin-left: 10px" />
                </div>
              </div>
            </a-col>
          </a-row>

          <a-form :form="form" :layout="'vertical'" @submit="submitPayment" id="billingInfo">
            <div v-if="paymentMethod === 'new'">
              <a-row>
                <a-col :md="{ span: 10, offset: 1 }">
                  <a-form-item :label="$t('label.firstNameFirstHalfChurchName')">
                    <a-input data-recurly="first_name" v-decorator="['first_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputFirstName') }] }]" />
                  </a-form-item>
                </a-col>
                <a-col :md="{ span: 10, offset: 1 }">
                  <a-form-item :label="$t('label.lastNameSecondHalfChurchName')">
                    <a-input data-recurly="last_name" v-decorator="['last_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputLastName') }] }]" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :md="{ span: 10, offset: 1 }">
                  <a-form-item :label="$t('label.cardNumber')">
                    <a-input
                      @keypress.native="isNumber($event)"
                      data-recurly="number"
                      autocomplete="cc-number"
                      v-decorator="['number', { rules: [{ required: true, message: $t('placeholder.pleaseInputCardNumber') }] }]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="{ span: 10, offset: 1 }">
                  <a-form-item :label="$t('label.expirationDate')" :style="{ display: 'inline-block', width: '180px' }">
                    <a-input-group compact>
                      <a-input
                        data-recurly="month"
                        name="month"
                        autocomplete="cc-exp-year"
                        style="width: 50px; text-align: center"
                        placeholder="MM"
                        :maxLength="2"
                        v-decorator="['expirationMonth', { rules: [{ required: true }] }]"
                      />
                      <a-input style="width: 30px; border-left: 0; pointer-events: none; backgroundcolor: #fff; text-align: center; padding: 0" placeholder="/" disabled />
                      <a-input
                        data-recurly="year"
                        name="year"
                        autocomplete="cc-exp-month"
                        style="width: 50px; border-left: 0; text-align: center"
                        :maxLength="2"
                        placeholder="YY"
                        v-decorator="['expirationYear', { rules: [{ required: true }] }]"
                      />
                    </a-input-group>
                  </a-form-item>
                  <a-form-item :label="$t('label.CVV')" :style="{ display: 'inline-block', width: '110px', 'margin-left': '20px' }">
                    <a-input
                      @keypress.native="isNumber($event)"
                      data-recurly="cvv"
                      autocomplete="cc-cvv"
                      :maxLength="3"
                      v-decorator="['cvv', { rules: [{ required: true, message: $t('placeholder.pleaseInputCVV') }] }]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :md="{ span: 10, offset: 1 }">
                  <a-form-item :label="'Billing Address'">
                    <a-input data-recurly="address1" v-decorator="['address1', { rules: [{ required: true }] }]" placeholder="Address 1" />
                  </a-form-item>
                </a-col>
                <a-col :md="{ span: 10, offset: 1 }">
                  <a-form-item :label="' '">
                    <a-input data-recurly="address2" v-decorator="['address2']" placeholder="Address 2" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :md="{ span: 10, offset: 1 }">
                  <a-form-item>
                    <a-input data-recurly="city" v-decorator="['city', { rules: [{ required: true }] }]" placeholder="City" />
                  </a-form-item>
                </a-col>
                <a-col :md="{ span: 10, offset: 1 }">
                  <a-form-item :style="{ display: 'inline-block', width: '180px' }">
                    <a-input data-recurly="state" v-decorator="['state', { rules: [{ required: true }] }]" placeholder="State" />
                  </a-form-item>
                  <a-form-item :style="{ display: 'inline-block', width: '110px', 'margin-left': '20px' }">
                    <a-input data-recurly="postal_code" v-decorator="['postal_code', { rules: [{ required: true }] }]" placeholder="Zip Code" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :md="{ span: 10, offset: 1 }">
                  <a-form-item> </a-form-item>
                </a-col>
              </a-row>

              <input type="hidden" data-recurly="country" value="US" />
              <input type="hidden" data-recurly="token" name="recurly_code" id="recurlyCode" />

              <a-row>
                <a-col :md="{ span: 22, offset: 1 }">
                  <p class="text-small">TrueLife.org accepts all major credit and debit cards</p>
                  <p><a-icon type="lock" /> Powered by Recurly</p>
                </a-col>
              </a-row>
            </div>
            <div class="text-right">
              <a-button key="back" @click="e => (showBillingModal = false)"> Cancel </a-button>
              <a-button key="submit" type="primary" class="tf-btn-primary ml-4" html-type="submit" :loading="isLoading"> Confirm </a-button>
            </div>
          </a-form>
        </a-modal>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { mapState } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import components from './step';
import { get, isEmpty, isFunction, forEach } from 'lodash';
import CardOrderService from '@/services/CardOrderService';
import PaymentService from '@/services/PaymentService';
import initRecurly from '@/services/Recurly';
import { empty } from '@/utils';

export default {
  name: 'Carousel',
  components: {
    ...components,
    Swiper,
    SwiperSlide,
  },
  props: {
    value: {
      type: Object,
    },
    dataSources: {
      type: Object,
    },
  },
  computed: {
    swiperInstance() {
      return get(this.$refs.swiper, 'swiperInstance');
    },
    ...mapState(['settings', 'user']),
    ...mapState({
      pricing: state => state.payment.pricing,
      billingInfo: state => state.payment.billingInfo,
    }),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    chargableMessage() {
      if (!this.pricing || !this.amountsToPay) {
        return '';
      }

      if (this.isPastor && this.extraPay) {
        return `You will be charged $${this.extraPay} to order ${this.amountsToPay} custom invitation cards designed just for you. This price includes the shipping! We will not print the cards until you approve the design over email.`;
      }

      const selected = this.pricing.find(p => Number(p.amount) === this.amountsToPay);
      return `You will be charged ${selected.currency}${selected.price} to order ${selected.amount} custom invitation cards designed just for you. This price includes the shipping! We will not print the cards until you approve the design over email.`;
    },
    getNextText() {
      if (!empty(this.nextText)) {
        return this.nextText;
      }
      if (this.isLoading) {
        return 'Please wait...';
      }
      return 'Next <i>→</i>';
    },
    frontCards() {
      return get(this.dataSources, 'front', []);
    },
    backCards() {
      return get(this.dataSources, 'back', []);
    },
    steps() {
      return [
        'Select The Card Front',
        'Card Back Design',
        'Name of Church',
        'Upload Files',
        'Church Email (Optional)',
        'Pastors Name',
        'Church Phone Number',
        'Website (Optional)',
        'Social Media Links (Optional)',
        'Church Address',
        'Service Times',
        'Shipping Address',
        'Amount of card orders',
        'Email to send Proofs',
        'Notes for the Designer',
      ];
    },
    stepsByRole() {
      return this.isPastor
        ? this.steps
        : ['Select The Card Front', 'Card Back Design', 'Name of Church', 'Shipping Address', 'Amount of card orders', 'Email to send Proofs', 'Notes for the Designer'];
    },
  },

  data() {
    return {
      dataInput: this.value,
      errorStep: 0,
      isLoading: false,
      showBillingModal: false,
      paymentMethod: 'current',
      amountsToPay: 0,
      extraPay: 0,
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        autoHeight: true,
        touchRatio: 0,
        breakpoints: {
          480: {
            autoHeight: false,
          },
        },
      },
      isAnimate: false,
      isErrorAnimated: false,
      isSeeAll: false,
      isError: false,
      errorText: '',
      currStep: 0,
      nextText: '',
      coupon_codes: '',
      isOrderProcessing: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'billingInfo' });
  },
  async mounted() {
    await initRecurly();
    await this.doInitData();
  },
  methods: {
    async doInitData() {
      if (isEmpty(this.pricing)) {
        await this.$store.dispatch('fetchPricing');
      }
      if (isEmpty(this.billingInfo)) {
        await this.$store.dispatch('fetchBillingInfo');
      }

      this.paymentMethod = this.billingInfo ? 'current' : 'new';
    },
    checkoutRecurly() {
      return new Promise((resolve, reject) => {
        recurly.token(document.getElementById('billingInfo'), err => {
          if (!isEmpty(err)) {
            reject(err);
          } else {
            resolve();
          }
        });
      });
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getCurrentStep(n) {
      return n;
    },
    handleError([value, step, errorText]) {
      this.errorText = errorText;
      this.isError = value;
      this.isErrorAnimated = false;
      if (value) {
        this.errorStep = step;
        setTimeout(() => {
          this.isErrorAnimated = true;
        }, 300);
      } else {
        this.errorStep = 0;
      }
    },
    onClickPagination(ind) {
      if (!this.dataInput.card_front && ind > 1) {
        this.handleError([true, this.currStep, 'Card Front is required.']);
        return;
      }

      if (!this.dataInput.card_back && ind > 2) {
        this.handleError([true, this.currStep, 'Card Back is required.']);
        return;
      }
      if (ind === (this.isPastor ? 12 : 4)) {
        ind++;
      }
      this.currStep = ind;
      this.swiperInstance.slideTo(ind);
      this.isAnimate = true;
      setTimeout(() => {
        this.isAnimate = false;
      }, 800);
    },
    seeAll() {
      if (this.isSeeAll) {
        this.detroySeeAll();
      } else {
        this.swiperInstance.params.touchRatio = 1;
        this.isSeeAll = true;
      }
    },
    detroySeeAll() {
      this.isSeeAll = false;
      this.swiperInstance.params.touchRatio = 0;
    },
    async onChangeSlide(type, forceNext = false) {
      if (type === 'next') {
        if (forceNext) {
          this.isError = false;
        }

        if (this.currStep <= this.stepsByRole.length) {
          const submit = get(this.$refs, `[Step${this.currStep}][0].submit`);
          if (isFunction(submit)) {
            await submit();
          }
          // if (this.currStep === 16) {
          //   const { submit } = this.$refs[`Step15`][0];
          //   if (isFunction(submit)) {
          //     await submit();
          //   }
          // }
          this.$nextTick(async () => {
            this.nextText = '';
            if (!this.isError || this.currStep !== this.errorStep) {
              if (this.currStep === this.stepsByRole.length) {
                if (this.isIndividual || (this.isPastor && this.dataInput.extra_pay)) {
                  this.amountsToPay = this.dataInput.extra_cards || this.dataInput.amount;
                  this.extraPay = this.dataInput.extra_pay;
                  this.showBillingModal = true;
                } else {
                  await this.submitPayment();
                }
              } else {
                this.swiperInstance.slideNext();
                this.currStep++;
              }
              if (this.currStep === this.stepsByRole.length + 1) {
                const { doAnimated } = this.$refs[`Step16`];
                if (isFunction(doAnimated)) {
                  doAnimated();
                }
              }
            }
          });
        }
      } else {
        this.swiperInstance.slidePrev();
        if (this.currStep > 0) {
          this.currStep--;
          this.nextText = '';
        }
      }
    },
    async submitPayment(e) {
      if (e) {
        e.preventDefault();
      }

      const submitOrder = async () => {
        if (this.currStep === this.stepsByRole.length) {
          try {
            await this.doSubmit();
            this.swiperInstance.slideNext();
            this.currStep++;
          } catch (error) {
            console.error({ error });
            if (error.message !== '1010') {
              this.$error({
                title: 'Error',
                content: error.response.data.error,
                class: 'no-button',
                centered: true,
              });
            }
          }
        }
      };

      if ((this.isPastor && !this.dataInput.extra_pay) || this.paymentMethod === 'current') {
        this.showBillingModal = false;
        this.isloading = true;
        await submitOrder();

        this.isloading = false;

        return;
      }

      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (!/^(0[1-9]|1[0-2])\/?([0-9]{2})$/gm.test(`${values.expirationMonth}/${values.expirationYear}`)) {
            this.$notification['error']({
              message: 'Error',
              description: 'The format of Expiration Date is invalid.',
            });

            return;
          }

          try {
            this.isLoading = true;
            try {
              await this.checkoutRecurly();
            } catch (e) {
              this.$notification['error']({
                message: 'Error',
                description: 'There was an error processing your payment information. Please check that all fields are filled in correctly and try again.',
              });

              return;
            }

            const resp = await PaymentService.setBillingInfo(document.getElementById('recurlyCode').value);
            this.$store.dispatch('updateBillingInfo', resp);
            this.form.resetFields();

            this.$notification['success']({
              message: 'Update successful.',
              description: `Credit Card Saved`,
            });

            this.showBillingModal = false;
            await submitOrder();
          } catch (error) {
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
    async doSubmit() {
      const dataSubmit = {
        user_id: this.user.user.userId,
      };
      for (let i = 1; i < this.stepsByRole.length; i++) {
        const submit = get(this.$refs, `[Step${i}][0].submit`);
        if (isFunction(submit)) {
          if (!this.isError) {
            await submit();
          }
          if (this.isError) {
            throw Error(1010);
          }
        }
      }
      forEach(this.dataInput, (value, key) => {
        if (!empty(value)) {
          dataSubmit[key] = value;
        }
      });
      dataSubmit['coupon_codes'] = this.coupon_codes;
      this.isOrderProcessing = true;
      await CardOrderService.doSubmitCard(dataSubmit);
      await this.$store.dispatch('fetchUser');
      this.isOrderProcessing = false;
    },
    doNextToMain() {
      this.swiperInstance.slideNext(300);
      this.currStep = 1;
    },
    doSelectCard(card) {
      this.$emit('onImgSource', card);
    },
    doSetCardSelected(type, index) {
      switch (type) {
        case 'front':
          this.$refs[`Step1`][0].doSetCardSelected(index);
          break;
        case 'back':
          this.$refs[`Step2`][0].doSetCardSelected(index);
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.carousel.orderCard {
  padding: 0;
  padding-bottom: 100px;
  position: relative;
  width: 100%;
  background: #3aa0f3;
  overflow: hidden;

  .swiper {
    &-wrapper {
      align-items: center;
    }
    &-container {
      transition: all 0.3s;
    }
    &-slide {
      // max-width: 800px;
      width: 90%;
      padding: 15px;
      opacity: 0;
      transition: all 0.3s;
      &-active {
        opacity: 1;
        .error-other {
          text-align: center;
          background-color: #df3030;
          color: #fff;
          margin-top: 0.6em;
          border-radius: 8px;
          padding: 0.5em;
        }
      }
      &.animated {
        animation: shake-box 0.3s ease-in-out 3;
      }
      .item {
        width: 100%;
        min-height: 50px;
        background: #fff;
        border-radius: 10px;
        box-shadow: rgba(#000, 0.25) 0 0 30px;
        position: relative;
        &-0 {
          background: #007ce2;
          border-radius: 0 0 10px 10px;
          .content-item * {
            color: #fff;
          }
          .nav-control {
            button {
              width: 100%;
              text-align: center;
            }
          }
        }
        .number {
          position: absolute;
          top: -100px;
          font-size: 80px;
          width: 100%;
          text-align: center;
          opacity: 0.8;
          display: none;
        }
      }
    }
  }

  &.activeAnimate {
    .swiper {
      &-container {
        transform: scale(0.6);
        overflow: unset;
      }
      &-wrapper {
        transition-delay: 0.3s;
      }
      &-slide {
        opacity: 1;
      }
    }
    .pagingControl {
      width: 90%;
      max-width: 90%;
    }
  }
  &.activeSeeAll {
    .swiper {
      &-container {
        transform: scale(0.6);
        overflow: unset;
      }
      &-wrapper {
        transition-delay: 0s;
      }
      &-slide {
        opacity: 1;
        padding: 50px 15px;
      }
    }
    .pagingControl {
      width: 90%;
      max-width: 90%;
    }

    .content-item {
      cursor: pointer;
    }
    .number {
      display: block !important;
    }
  }
  .pagingControl {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    width: 90%;
    // max-width: 800px;
    margin: 0 auto;
    transition: all 0.3s;
    border-bottom: 2px solid #fff;
    button {
      width: 0;
      height: 0;
      border: 0;
      position: relative;
      outline: none;
      cursor: pointer;
      transition: all 0.15s ease;
      background: transparent;
      &.active {
        .dot {
          transform: scale(3);
          background: #3aa0f3;
          border: 1px solid #fff;
        }
      }

      &.error {
        .dot {
          transform: scale(2);
          background: #df3030;
          border: 1px solid #fff;
        }
      }
      &.done {
        .dot {
          transform: scale(1.5);
          background: #6dbd00;
          border: 1px solid #fff;
        }
      }
      &:last-child .dot {
        left: 0px;
      }
      &:first-child .dot {
        left: -7px;
      }
      .dot {
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 20px;
        border: 0;
        position: relative;
        left: -5px;
        top: -4px;
        background: #fff;
        transition: all 0.3s;
        box-shadow: #999 0 0 5px;
      }
      .tooltip {
        position: absolute;
        left: 0;
        bottom: 25px;
        background: rgba(#000, 0.75);
        transform: translateX(-50%);
        white-space: nowrap;
        color: #fff;
        padding: 10px;
        border-radius: 5px;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s;
      }
      &:hover {
        .dot {
          transform: scale(2);
        }
        .tooltip {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
  .content-item {
    padding: 20px 40px;
    border-radius: 10px 10px 0 0;
    max-height: 50vh;
    overflow: auto;
    .heading {
      color: #323232;
      font-size: 24px;
      // text-transform: capitalize;
      text-align: center;
      margin-bottom: 10px;
    }
    .text {
      color: #adadad;
      font-size: 18px;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 20px;
      max-width: 90%;
    }
    .small-text {
      color: #adadad;
      font-size: 14px;
      text-align: center;
      margin-bottom: 20px;
      display: block;
    }
    &.dark {
      background: #007ce2;
      .heading,
      .text,
      .small-text {
        color: #fff;
      }
    }
  }
  .form-group {
    margin-bottom: 20px;
    .form-input,
    .form-textarea {
      width: 100%;
      border: 1px solid #a9b3c6;
      border-radius: 3px;
      padding: 0 10px;
      height: 50px;
      transition: all 0.3s;
      &:focus {
        box-shadow: 0 0 0 2px rgba(74, 133, 239, 0.3);
      }
      &.error {
        border: 1px solid #e34343;
      }
    }
    .form-textarea {
      height: 150px;
      resize: none;
      padding: 15px;
    }
  }
  .nav-control {
    background: #9dc83b;
    width: 100%;
    border-radius: 0 0 10px 10px;
    display: flex;
    overflow: hidden;
    position: relative;
    .error {
      position: absolute;
      top: 10px;
      color: #fff;
      background: rgba(0, 0, 0, 0.7);
      padding: 0.4em 0.8em;
      font-weight: 300;
      border-radius: 3px;
      font-size: 0.75em;
      cursor: none;
      &.step6,
      &.step16 {
        left: calc(50% - 175px);
        max-width: 350px;
      }
      &.step1,
      &.step2,
      &.step4,
      &.step5,
      &.step14,
      &.step15 {
        left: calc(50% - 70px);
      }
    }
    button {
      width: 50%;
      height: 50px;
      color: #fff;
      text-transform: uppercase;
      padding: 0 30px;
      border: 0;
      background: #9ec83a;
      font-size: 18px;
      text-align: left;
      cursor: pointer;
      transition: all 0.3s;
      i {
        position: relative;
        right: 0.7em;
      }
      &:hover {
        background: #7ba21e;
      }
      &.nav-next {
        border-left: 1px solid #a9ce51;
        text-align: right;
        i {
          right: -0.7em;
        }
        &:hover i {
          animation: animateNext 1s 1;
        }
        &.no-back {
          width: 100%;
        }
      }
    }
  }
  .see-all {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 15px;
    margin: auto;
    width: 140px;
    height: 40px;
    background: #338dd7;
    border-radius: 3px;
    color: #fff;
    .text {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    button {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: #338dd7;
      border: 0;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      opacity: 0;
    }
    &:hover {
      button {
        opacity: 1;
      }
    }
  }
  .radio-item {
    width: 100%;
    position: relative;
    &:hover .hoverClass {
      width: 100%;
      z-index: 99;
      button {
        display: block;
      }
    }
    &.selected:hover .hoverClass {
      background: rgba(0, 0, 0, 0.15);
    }
    .hoverClass {
      position: absolute;
      width: 0;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      z-index: -1;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.4s ease-in-out;
      button {
        display: none;
      }
    }
    label {
      display: block;
      width: 100%;
      text-align: center;
      border: 1px solid #e5e5e5;
      border-radius: 5px;
      margin-bottom: 20px;
      padding: 15px;
      position: relative;
      cursor: pointer;
      transition: all 0.3s;
      // &:after {
      //   content: '';
      //   position: absolute;
      //   width: 15px;
      //   left: 15px;
      //   top: 10px;
      //   width: 15px;
      //   height: 15px;
      //   border: 1px solid #e5e5e5;
      //   border-radius: 10px;
      //   background: #fff;
      //   transition: all 0.3s;
      // }
      img {
        width: 90%;
      }
      &:hover {
        border-color: #5badfe;
      }
    }
    input[type='radio'] {
      display: none;
      &:checked ~ label {
        animation: blink2 0.15s linear 2 normal forwards;
      }
      &:checked ~ label:after {
        border-color: #5badfe;
        background: #5badfe;
        box-shadow: inset #fff 0 0 0 3px;
      }
    }
  }
  .form-upload {
    border: 2px dashed #4987c5;
    border-radius: 10px;
    background-color: #f4f7fa;
    padding: 16px;
    text-align: center;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .ant-upload {
      border: none;
      background: #4987c5;
      color: #fff;
      margin: 0;
      margin: auto;
      float: none;
      &.ant-upload-select-picture-card {
        width: initial;
        height: initial;
        padding: 0 20px;
      }
    }
  }
}
@keyframes blink2 {
  0% {
    background-color: transparent;
    border-color: #a9b3c6;
  }
  100% {
    border-color: #5badfe;
    background-color: #d7ebff;
  }
}
@-webkit-keyframes animateNext {
  25% {
    right: -1.2em;
  }
  50% {
    right: -0.7em;
  }
  75% {
    right: -1em;
  }
  100% {
    right: -0.7em;
  }
}
@keyframes animateNext {
  25% {
    right: -1.2em;
  }
  50% {
    right: -0.7em;
  }
  75% {
    right: -1em;
  }
  100% {
    right: -0.7em;
  }
}

@keyframes shake-box {
  0% {
    transform: translateX(30px);
  }
  50% {
    transform: translateX(-30px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
